import { components } from "@/api-schema";
import { RELOCATION_ORDER_STATUS_FILTER_OPTIONS } from "@/components/filter/predefined/relocation-order-status-filter";
import { RowAction, RowActionVariant } from "@/components/ui/table-row-actions";
import { VehicleSummaryCard } from "@/components/relocation-order/vehicle-summary-card";
import { CheckIcon, XIcon } from "lucide-react";
import { RelocationOrderActionsContext } from "@/common/hooks/relocation-order/_helpers/relocation-order-actions-context";

type RelocationOrder = components["schemas"]["RelocationOrder"];

export function buildDestinationBranchActions(
  order: RelocationOrder,
  context: RelocationOrderActionsContext,
): RowAction[] {
  if (order.status !== RELOCATION_ORDER_STATUS_FILTER_OPTIONS.Transport_Company_Awaiting_Delivery_Acceptance.id) {
    return [];
  }

  return [
    {
      label: context.t("fit:AcceptVehicle"),
      icon: <CheckIcon className="h-4 w-4" />,
      variant: RowActionVariant.Success,
      needsConfirm: true,
      confirmLabels: {
        title: context.t("fit:AcceptVehicle"),
        text: context.t("fit:DoYouWantToAcceptThisVehicle"),
        confirmButton: context.t("common:Accept"),
      },
      confirmCustomComponent: <VehicleSummaryCard vehicle={order.vehicle} />,
      onClick: () => context.handleAcceptVehicle(order),
    },
    {
      label: context.t("fit:ReportProblem"),
      icon: <XIcon className="h-4 w-4" />,
      variant: RowActionVariant.Error,
      onClick: () => context.handleRejectVehicle(order),
    },
  ];
}
